// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fVpnO","col":"styles_col__1oa4U"};